<template>
    <div id="baby-paradise" v-loading="loading">
        <div class="title">订单管理 > 亲子项目订单 > <span class="title-detail" @click="$router.go(-1)"> 订单详情</span></div>
        <el-card class="main">
            <div class="table">
                <div class="table-title">
                    <img src="@/assets/icon/baby-paradise/icon_yonghuxx@2x.png" alt="">
                    <span>用户信息</span>
                </div>
                <el-table :data="userInfo" style="width: 100%; margin-top: 24px; margin-left: 24px;"  :header-cell-style="getRowClass" border>
                    <el-table-column prop="spu_name" label="景区名称"></el-table-column>
                    <el-table-column prop="scenic_spot" label="景区种类"></el-table-column>
                    <el-table-column prop="user_name" label="用户名称"></el-table-column>
                    <el-table-column prop="user_phone" label="联系电话"></el-table-column>
                    <el-table-column prop="order_status" label="订单状态"></el-table-column>
                </el-table>
            </div>
            <div class="table">
                <div class="table-title">
                    <img src="@/assets/icon/baby-paradise/icon_yonghuxx@2x(1).png" alt="">
                    <span>商品信息</span>
                </div>
                <el-table :data="shopInfo" style="width: 80%; margin-top: 24px; margin-left: 24px;"  :header-cell-style="getRowClass" border>
                    <el-table-column prop="sku_name" label="门票名称"></el-table-column>
                    <el-table-column prop="sku_one_price" label="门票单价"></el-table-column>
                    <el-table-column prop="sku_num" label="门票数量"></el-table-column>
                    <el-table-column prop="price_order" label="金额小计"></el-table-column>
                </el-table>
            </div>
            <div class="table" style="padding-left: 80px;">
                <span>总计：{{ data.price_order }}</span>
                <span style="margin-left: 12px;">优惠：0</span>
                <span style="margin-left: 12px;">应付：{{ data.price_pay }}</span>
            </div>
            <div class="table" v-if="table3Status">
                <div class="table-title">
                    <img src="@/assets/icon/baby-paradise/icon_yonghuxx@2x(2).png" alt="">
                    <span>入园游客</span>
                </div>
                <el-table :data="visitorInfo" style="width: 100%; margin-top: 24px; margin-left: 24px;"  :header-cell-style="getRowClass" border>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="user_phone" label="联系电话"></el-table-column>
                    <el-table-column prop="card_no" label="身份证号"></el-table-column>
                    <el-table-column v-if="column3Status" prop="making_appointments" label="预约日期"></el-table-column>
                    <el-table-column v-if="column3Status" prop="time_used" label="是否核销"></el-table-column>
                </el-table>
            </div>
            <div class="table" v-if="data.order_status == 6 && data.comment">
                <div class="table-title">
                    <img src="@/assets/icon/baby-paradise/icon_yonghuxxap@2x.png" alt="">
                    <span>用户评价</span>
                </div>
                <!-- 用户评价····字段未更改 -->
                <el-table :data="userEvaluation" style="width: 80%; margin-top: 24px; margin-left: 24px;"  :header-cell-style="getRowClass" border>
                    <el-table-column prop="created_at" label="评价时间"></el-table-column>
                    <el-table-column prop="content" label="评价内容"></el-table-column>
                    <el-table-column prop="image" label="评价图片">
                        <template slot-scope="{row}">
                            <el-image 
                                v-if="row.has_image"
                                style="width: 100px; height: 100px"
                                :src="row.image[0]" 
                                :preview-src-list="row.image">
                            </el-image>
                            <span v-else>用户未上传图片</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="start_tag" label="评价分数"></el-table-column>
                </el-table>
            </div>
        </el-card>
        <el-card class="bottom" v-if="btnStatus && btnText">
            <el-button type="primary" style="float: right;" @click="onOpenDialog">{{ btnText }}</el-button>
        </el-card>
        <el-dialog
            title="提示"
            :visible.sync="cancelDialog"
            width="30%">
            <p>是否执行取消订单操作</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog = false">取 消</el-button>
                <el-button type="primary" @click="onSure(4)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="afterSaleDialog"
            width="30%">
            <p>是否执行申请售后操作</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="afterSaleDialog = false">取 消</el-button>
                <el-button type="primary" @click="onSure(3)">确 定</el-button>
            </span>
        </el-dialog>
         <el-dialog
            title="审核"
            :visible.sync="passDialog"
            width="30%">
            <el-radio-group v-model="check">
                <el-radio :label="1">审核成功</el-radio>
                <el-radio :label="0">审核失败</el-radio>
            </el-radio-group>
            <template v-if="check==0">
                <el-input type="textarea" style="margin-top: 12px;" placeholder="输入失败原因" v-model="whyFail" maxlength="200" show-word-limit></el-input>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passDialog = false">取 消</el-button>
                <el-button type="primary" @click="onSure(12)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getBabyOrderDetail, setBabyOrderOption } from '@/api/baby/order.js';
export default {
    data () {
        return {
            loading: false,
            data: {},
            cancelDialog: false,
            afterSaleDialog: false,
            passDialog: false,
            check: 1,
            whyFail: ''
        }
    }, 
    computed: {
        // 用户信息
        userInfo () {
            let data = this.data;
            let scenic_spot = '景区';
            if (this.$route.query.scenic_spot) {
                scenic_spot = this.$route.query.scenic_spot;
            }
            return [
                { 
                    spu_name: data.spu_name,
                    scenic_spot,           
                    user_name: data.user_name, 
                    user_phone: data.user_phone,
                    order_status: this.statusName(data.order_status, data.order_refund)
                }
            ]
        },
        // 商品信息
        shopInfo () {
            let data = this.data;
            return [
                {
                    sku_name: data.sku_name,
                    sku_one_price: data.sku_one_price,
                    sku_num: data.sku_num,
                    price_order: data.price_order
                }
            ]
        },
        // 入园游客
        visitorInfo () {
            let data = this.data;
            if (!data.user_card_list) {
                return []
            }
            return data.user_card_list.map(item => {
                return {
                    name: item.name,
                    card_no: item.card_no,
                    user_phone: data.user_phone,
                    making_appointments: data.making_appointments,
                    time_used: data.time_used ? '是' : '否'
                }
            })
        },
        // 用户评价
        userEvaluation () {
            let data = this.data;
            if (!data.comment) {
                return []
            }
            return [
                {
                    created_at: data.created_at,        // 评价时间
                    content: data.comment.content,      // 评价内容
                    has_image: data.comment.has_image,  // 是否有图片
                    image: data.comment.image,          // 图片列表
                    start_tag: data.comment.start_tag   // 评价分数
                }
            ]
        },
        // 右下角按是否展示状态
        btnStatus () {
            let data = this.data;
            // 未支付
            if (data.order_status == 1) {
                return true
            }
            // 待预约
            if (data.order_status == 2) {
                return true
            }
            // 待使用
            if (data.order_status == 3) {
                return true
            }
            // 待退款（待预约）
            if (data.order_status == 2 && data.order_refund == 1) {
                return true
            }
            // 待退款（待使用）
            if (data.order_status == 3 && data.order_refund == 1) {
                return true
            }
            return false
        },
        // 入园游客列表展示状态
        table3Status () {
            let data = this.data;
            if (data.order_status == 1) {
                return false
            }
            if (data.order_status == 5) {
                return false
            }
            return true
        },
        // 入园游客列表列展示状态
        column3Status () {
            let data = this.data;
            if (data.order_status == 2) {
                return false
            }
            if (data.order_status == 2 && data.order_refund == 1) {
                return false
            }
            if (data.order_status == 2 && data.order_refund == 2) {
                return false
            }
            return true
        },
        // 右下角按钮文字
        btnText () {
            let data = this.data;
            if (data.order_refund == 1 && data.order_status == 3) {
                return '审核'
            }
            if (data.order_refund == 1 && data.order_status == 2) {
                return '审核'
            }
            if (data.order_status == 2) {
                return '申请售后'
            }
            if (data.order_status == 3) {
                return '申请售后'
            }
            if (data.order_status == 1) {
                return '取消订单'
            }
            return '申请售后'
        }
    },
    methods: {
        statusName (k1, k2) {
            if (k2 == 0 || k2 == null) {
                switch (k1) {
                    case 1:
                    return '待支付'
                    case 2:
                    return '待预约'
                    case 3:
                    return '待使用'
                    case 4:
                    return '待评价'
                    case 5:
                    return '已取消'
                    case 6:
                    return '已完成'
                    case 7:
                    return '已关闭'
                }
            } else {
                if (k2 == 1) {
                    return '待退款'
                } else if (k2 == 2) {
                    // return '退款成功'
                    return '已关闭'
                } else if (k2 == 3 || k2 == 4) {
                    return '退款失败'
                }
            }
        },
        handleSizeChange (page) {
            this.pageSize = page;
            this.initTable();
        },
        handleCurrentChange (page) {
            this.currentPage = page;
            this.initTable();
        },
        // 弹框点击确认按钮
        onSure (num) {
            let params = {
                order_sn: this.$route.query.order_sn   // 订单单号
            }
            if (num == 4) {
                params.options = 4
            }

            if (num == 3) {
                params.options = 3
            }

            if (num == 12) {
                if (this.check == 0) {
                    params.options = 2
                    params.refund_message = this.whyFail;
                } else {
                    params.options = 1
                }
            }
            setBabyOrderOption(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.initTable();
                        this.closeDialog();
                        this.$message.success('已完成！')
                        this.whyFail = '';
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        },
        // 取消订单或申请售后触发事件
        onOpenDialog () {
            if (this.btnText == '取消订单') {
                this.cancelDialog = true;
            } else if (this.btnText == '申请售后'){
                this.afterSaleDialog = true;
            } else if (this.btnText == '审核') {
                this.passDialog = true;
            }
        },
        // 取消订单或申请售后触发事件
        closeDialog () {
            if (this.btnText == '取消订单') {
                this.cancelDialog = false;
            } else if (this.btnText == '申请售后'){
                this.afterSaleDialog = false;
            } else if (this.btnText == '审核') {
                this.passDialog = false;
            }
        },
        initTable () {
            if (!this.$route.query.order_sn) {
                return
            }
            let params = {
                order_sn: this.$route.query.order_sn
            }
            this.loading = true;
            getBabyOrderDetail(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.data = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg)
                })
                .finally(_ => {
                    this.loading = false;
                })
        },
        getRowClass () {
            return 'background: #f5f7fa'
        }
    },
    created () {
        this.initTable();
    }
}
</script>

<style lang="scss" scoped>
    #baby-paradise {
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            font-weight: 600;
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
            .title-detail {
                margin-left: 12px;
                cursor: pointer;
            }
        }
        .main {
            margin: 24px 24px 2px 24px;
            border-radius: 0;
            padding-right: 120px;
            min-height: 600px;
            .table {
                padding: 20px 60px 20px 60px;
            }
            .table-title {
                display: flex;
                align-items: center;
                span {
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 40px;
                    margin-left: 12px;
                }
            }
        }
        
    }

    .bottom {
        margin: 2px 24px 24px 24px;
        padding-bottom: 18px;
    }

    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #F1F1F1;
        font-weight: bold;
    }
    
    ::v-deep .el-dialog {
        border-radius: 10px;
        min-width: 580px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #F1F1F1;
        padding: 10px 20px 10px;
    }

    ::v-deep .el-dialog__body {
        padding: 60px 80px;
    }
</style>